import { type FieldTemplateProps } from '@rjsf/core';
import { type FC } from 'react';

export const FieldTemplate: FC<FieldTemplateProps> = ({ children }) => children;
